module.exports = __webpack_public_path__ + "img/7_96.0774c6ac.png";